import styled, {css} from 'styled-components';

import {Button as BaseButton, Price as BasePrice} from '@edna/components';
import {Column as BaseColumn, SkeletonItem} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {BigText as BaseBigText} from 'src/components/primitives';

export const StartColumn = styled(BaseColumn)`
  ${mixins.flexAlign('flex-start', 'flex-start')};
`;

export const SmallStartColumn = styled(StartColumn)`
  padding-right: ${({theme}) => theme.spacing.s8};
`;

export const Content = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.s8};
`;

type TCenterRowProps = {
  hasTopIndent?: boolean;
};

export const CenterRow = styled.div<TCenterRowProps>`
  ${mixins.flexAlign('initial', 'center')}
  flex-flow: row wrap;
  margin-top: ${({theme, hasTopIndent}) => (hasTopIndent ? theme.spacing.s4 : 0)};
`;

type TButtonProps = {
  hasTopIndent?: boolean;
};

export const Button = styled(BaseButton)<TButtonProps>`
  ${({theme: {spacing}, hasTopIndent}) => css`
    margin: ${hasTopIndent ? spacing.s4 : 0} ${spacing.s2} 0 0;
  `}
`;

type TDetailsLabelProps = {
  fullWidth?: boolean;
};

export const DetailsLabel = styled.div<TDetailsLabelProps>`
  ${mixins.f3}
  ${({theme, fullWidth}) => css`
    flex: ${fullWidth ? '1 0 100%' : '0 0 auto'};
    color: ${theme.branding.content.secondary};
    margin-right: ${theme.spacing.s1};

    &::after {
      content: ':';
    }
  `}
`;

export const LargeSkeleton = styled(SkeletonItem)`
  min-width: 100%;
`;

export const BigText = styled(BaseBigText)`
  ${mixins.f4}
  margin-bottom: 0;
`;

export const DetailsContainer = styled.div`
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const EditButton = styled(Button)`
  height: auto;
  ${({theme}) => css`
    margin-left: ${theme.spacing.s2};
    padding: ${theme.spacing.s1};
    border: 1px solid ${theme.palette.black};
    border-radius: 6px;
  `}
`;

export const Price = styled(BasePrice)`
  ${mixins.f3}
  color: ${({theme}) => theme.branding.content.primary};
  font-weight: 400;
`;
